/**
 *  This file was auto generated by angular schematics.
 *  For update use script from package.json
 */

import { ColorsMap } from './generated-types';

export const $darkPalette: ColorsMap = {
  /** as theme map variable danger-color */
  dangerColor: {
    type: 'color',

    rgba: 'rgba(231, 73, 91, 1)',
    hex: '#E7495B',
    r: 231,
    g: 73,
    b: 91,
    a: 1,
  },

  /** as theme map variable success-color */
  successColor: {
    type: 'color',

    rgba: 'rgba(35, 213, 128, 1)',
    hex: '#23D580',
    r: 35,
    g: 213,
    b: 128,
    a: 1,
  },

  /** as theme map variable bg-main-color */
  bgMainColor: {
    type: 'color',

    rgba: 'rgba(56, 61, 78, 1)',
    hex: '#383D4E',
    r: 56,
    g: 61,
    b: 78,
    a: 1,
  },

  /** as theme map variable bg-addit-color */
  bgAdditColor: {
    type: 'color',

    rgba: 'rgba(244, 246, 255, 1)',
    hex: '#F4F6FF',
    r: 244,
    g: 246,
    b: 255,
    a: 1,
  },

  /** as theme map variable bg-addit-2-color */
  bgAddit2Color: {
    type: 'color',

    rgba: 'rgba(171, 179, 206, 1)',
    hex: '#ABB3CE',
    r: 171,
    g: 179,
    b: 206,
    a: 1,
  },

  /** as theme map variable bg-addit-3-color */
  bgAddit3Color: {
    type: 'color',

    rgba: 'rgba(245, 245, 245, 1)',
    hex: '#F5F5F5',
    r: 245,
    g: 245,
    b: 245,
    a: 1,
  },

  /** as theme map variable text-color */
  textColor: {
    type: 'color',

    rgba: 'rgba(255, 255, 255, 1)',
    hex: '#FFFFFF',
    r: 255,
    g: 255,
    b: 255,
    a: 1,
  },

  /** as theme map variable text-addit-color */
  textAdditColor: {
    type: 'color',

    rgba: 'rgba(104, 111, 137, 1)',
    hex: '#686F89',
    r: 104,
    g: 111,
    b: 137,
    a: 1,
  },

  /** as theme map variable border-color */
  borderColor: {
    type: 'color',

    rgba: 'rgba(171, 179, 206, 1)',
    hex: '#ABB3CE',
    r: 171,
    g: 179,
    b: 206,
    a: 1,
  },

  /** as theme map variable border-addit-color */
  borderAdditColor: {
    type: 'color',

    rgba: 'rgba(229, 236, 252, 1)',
    hex: '#E5ECFC',
    r: 229,
    g: 236,
    b: 252,
    a: 1,
  },

  /** as theme map variable border-addit-2-color */
  borderAddit2Color: {
    type: 'color',

    rgba: 'rgba(229, 229, 255, 1)',
    hex: '#E5E5FF',
    r: 229,
    g: 229,
    b: 255,
    a: 1,
  },

  /** as theme map variable border-btn-color */
  borderBtnColor: {
    type: 'color',

    rgba: 'rgba(104, 111, 137, 1)',
    hex: '#686F89',
    r: 104,
    g: 111,
    b: 137,
    a: 1,
  },

  /** as theme map variable button-primary-color */
  buttonPrimaryColor: {
    type: 'color',

    rgba: 'rgba(56, 61, 78, 1)',
    hex: '#383D4E',
    r: 56,
    g: 61,
    b: 78,
    a: 1,
  },

  /** as theme map variable inactive-color */
  inactiveColor: {
    type: 'color',

    rgba: 'rgba(171, 179, 206, 1)',
    hex: '#ABB3CE',
    r: 171,
    g: 179,
    b: 206,
    a: 1,
  },

  /** as theme map variable success-light-color */
  successLightColor: {
    type: 'color',

    rgba: 'rgba(15, 172, 39, 1)',
    hex: '#0FAC27',
    r: 15,
    g: 172,
    b: 39,
    a: 1,
  },

  /** as theme map variable success-blue-color */
  successBlueColor: {
    type: 'color',

    rgba: 'rgba(97, 122, 255, 1)',
    hex: '#617AFF',
    r: 97,
    g: 122,
    b: 255,
    a: 1,
  },

  /** as theme map variable success-blue-2-color */
  successBlue2Color: {
    type: 'color',

    rgba: 'rgba(110, 174, 249, 1)',
    hex: '#6EAEF9',
    r: 110,
    g: 174,
    b: 249,
    a: 1,
  },

  /** as theme map variable dark-purple-color */
  darkPurpleColor: {
    type: 'color',

    rgba: 'rgba(118, 61, 239, 1)',
    hex: '#763DEF',
    r: 118,
    g: 61,
    b: 239,
    a: 1,
  },

  /** as theme map variable warning-color */
  warningColor: {
    type: 'color',

    rgba: 'rgba(255, 176, 57, 1)',
    hex: '#FFB039',
    r: 255,
    g: 176,
    b: 57,
    a: 1,
  },

  /** as theme map variable bg-dark-color */
  bgDarkColor: {
    type: 'color',

    rgba: 'rgba(56, 61, 78, 1)',
    hex: '#383D4E',
    r: 56,
    g: 61,
    b: 78,
    a: 1,
  },

  /** as theme map variable bg-additional-color */
  bgAdditionalColor: {
    type: 'color',

    rgba: 'rgba(56, 61, 78, 1)',
    hex: '#383D4E',
    r: 56,
    g: 61,
    b: 78,
    a: 1,
  },

  /** as theme map variable bg-additional-2-color */
  bgAdditional2Color: {
    type: 'color',

    rgba: 'rgba(244, 246, 255, 1)',
    hex: '#F4F6FF',
    r: 244,
    g: 246,
    b: 255,
    a: 1,
  },

  /** as theme map variable bg-block-main-color */
  bgBlockMainColor: {
    type: 'color',

    rgba: 'rgba(245, 245, 245, 1)',
    hex: '#F5F5F5',
    r: 245,
    g: 245,
    b: 245,
    a: 1,
  },

  /** as theme map variable bg-block-addit-color */
  bgBlockAdditColor: {
    type: 'color',

    rgba: 'rgba(237, 237, 237, 1)',
    hex: '#EDEDED',
    r: 237,
    g: 237,
    b: 237,
    a: 1,
  },

  /** as theme map variable bg-block-extra-color */
  bgBlockExtraColor: {
    type: 'color',

    rgba: 'rgba(55, 67, 100, 1)',
    hex: '#374364',
    r: 55,
    g: 67,
    b: 100,
    a: 1,
  },

  /** as theme map variable bg-extra-color */
  bgExtraColor: {
    type: 'color',

    rgba: 'rgba(56, 61, 78, 1)',
    hex: '#383D4E',
    r: 56,
    g: 61,
    b: 78,
    a: 1,
  },

  /** as theme map variable bg-light-blue-addit */
  bgLightBlueAddit: {
    type: 'color',

    rgba: 'rgba(233, 236, 248, 1)',
    hex: '#E9ECF8',
    r: 233,
    g: 236,
    b: 248,
    a: 1,
  },

  /** as theme map variable bg-light-blue-addit-2 */
  bgLightBlueAddit2: {
    type: 'color',

    rgba: 'rgba(225, 237, 250, 1)',
    hex: '#E1EDFA',
    r: 225,
    g: 237,
    b: 250,
    a: 1,
  },

  /** as theme map variable bg-light-blue-addit-3 */
  bgLightBlueAddit3: {
    type: 'color',

    rgba: 'rgba(250, 250, 255, 1)',
    hex: '#FAFAFF',
    r: 250,
    g: 250,
    b: 255,
    a: 1,
  },

  /** as theme map variable bg-dashboard */
  bgDashboard: {
    type: 'color',

    rgba: 'rgba(104, 111, 137, 1)',
    hex: '#686F89',
    r: 104,
    g: 111,
    b: 137,
    a: 1,
  },

  /** as theme map variable bg-dashboard-addit */
  bgDashboardAddit: {
    type: 'color',

    rgba: 'rgba(56, 61, 78, 1)',
    hex: '#383D4E',
    r: 56,
    g: 61,
    b: 78,
    a: 1,
  },

  /** as theme map variable text-additional-color */
  textAdditionalColor: {
    type: 'color',

    rgba: 'rgba(171, 179, 206, 1)',
    hex: '#ABB3CE',
    r: 171,
    g: 179,
    b: 206,
    a: 1,
  },

  /** as theme map variable text-additional-2-color */
  textAdditional2Color: {
    type: 'color',

    rgba: 'rgba(158, 158, 158, 1)',
    hex: '#9E9E9E',
    r: 158,
    g: 158,
    b: 158,
    a: 1,
  },

  /** as theme map variable text-additional-3-color */
  textAdditional3Color: {
    type: 'color',

    rgba: 'rgba(104, 111, 137, 1)',
    hex: '#686F89',
    r: 104,
    g: 111,
    b: 137,
    a: 1,
  },

  /** as theme map variable text-extra-color */
  textExtraColor: {
    type: 'color',

    rgba: 'rgba(175, 175, 175, 1)',
    hex: '#AFAFAF',
    r: 175,
    g: 175,
    b: 175,
    a: 1,
  },

  /** as theme map variable text-inverse-color */
  textInverseColor: {
    type: 'color',

    rgba: 'rgba(56, 61, 78, 1)',
    hex: '#383D4E',
    r: 56,
    g: 61,
    b: 78,
    a: 1,
  },

  /** as theme map variable text-static-color */
  textStaticColor: {
    type: 'color',

    rgba: 'rgba(56, 61, 78, 1)',
    hex: '#383D4E',
    r: 56,
    g: 61,
    b: 78,
    a: 1,
  },

  /** as theme map variable text-link-color */
  textLinkColor: {
    type: 'color',

    rgba: 'rgba(161, 86, 236, 1)',
    hex: '#A156EC',
    r: 161,
    g: 86,
    b: 236,
    a: 1,
  },

  /** as theme map variable border-color-additional */
  borderColorAdditional: {
    type: 'color',

    rgba: 'rgba(240, 240, 240, 1)',
    hex: '#F0F0F0',
    r: 240,
    g: 240,
    b: 240,
    a: 1,
  },

  /** as theme map variable border-color-additional-2 */
  borderColorAdditional2: {
    type: 'color',

    rgba: 'rgba(234, 234, 234, 1)',
    hex: '#EAEAEA',
    r: 234,
    g: 234,
    b: 234,
    a: 1,
  },

  /** as theme map variable border-color-light */
  borderColorLight: {
    type: 'color',

    rgba: 'rgba(82, 91, 116, 1)',
    hex: '#525B74',
    r: 82,
    g: 91,
    b: 116,
    a: 1,
  },

  /** as theme map variable border-color-dark */
  borderColorDark: {
    type: 'color',

    rgba: 'rgba(56, 61, 78, 1)',
    hex: '#383D4E',
    r: 56,
    g: 61,
    b: 78,
    a: 1,
  },

  /** as theme map variable shadow-color */
  shadowColor: {
    type: 'color',

    rgba: 'rgba(0, 0, 0, 0.08)',
    hex: '#000000',
    r: 0,
    g: 0,
    b: 0,
    a: 0.08,
  },

  /** as theme map variable box-shadow */
  boxShadow: {
    type: 'box-shadow',

    rgba: 'rgba(0, 0, 0, 0.08)',
    hex: '#000000',
    r: 0,
    g: 0,
    b: 0,
    a: 0.08,

    boxShadowParams: ['0', '0', '16px'],
  },

  /** as theme map variable field-focused-color */
  fieldFocusedColor: {
    type: 'color',

    rgba: 'rgba(247, 243, 195, 0.75)',
    hex: '#F7F3C3',
    r: 247,
    g: 243,
    b: 195,
    a: 0.75,
  },
};

export const $lightPalette: ColorsMap = {
  /** as theme map variable danger-color */
  dangerColor: {
    type: 'color',

    rgba: 'rgba(231, 73, 91, 1)',
    hex: '#E7495B',
    r: 231,
    g: 73,
    b: 91,
    a: 1,
  },

  /** as theme map variable success-color */
  successColor: {
    type: 'color',

    rgba: 'rgba(35, 213, 128, 1)',
    hex: '#23D580',
    r: 35,
    g: 213,
    b: 128,
    a: 1,
  },

  /** as theme map variable bg-main-color */
  bgMainColor: {
    type: 'color',

    rgba: 'rgba(255, 255, 255, 1)',
    hex: '#FFFFFF',
    r: 255,
    g: 255,
    b: 255,
    a: 1,
  },

  /** as theme map variable bg-addit-color */
  bgAdditColor: {
    type: 'color',

    rgba: 'rgba(244, 246, 255, 1)',
    hex: '#F4F6FF',
    r: 244,
    g: 246,
    b: 255,
    a: 1,
  },

  /** as theme map variable bg-addit-2-color */
  bgAddit2Color: {
    type: 'color',

    rgba: 'rgba(226, 228, 238, 1)',
    hex: '#E2E4EE',
    r: 226,
    g: 228,
    b: 238,
    a: 1,
  },

  /** as theme map variable bg-addit-3-color */
  bgAddit3Color: {
    type: 'color',

    rgba: 'rgba(245, 245, 245, 1)',
    hex: '#F5F5F5',
    r: 245,
    g: 245,
    b: 245,
    a: 1,
  },

  /** as theme map variable text-color */
  textColor: {
    type: 'color',

    rgba: 'rgba(56, 61, 78, 1)',
    hex: '#383D4E',
    r: 56,
    g: 61,
    b: 78,
    a: 1,
  },

  /** as theme map variable text-addit-color */
  textAdditColor: {
    type: 'color',

    rgba: 'rgba(104, 111, 137, 1)',
    hex: '#686F89',
    r: 104,
    g: 111,
    b: 137,
    a: 1,
  },

  /** as theme map variable border-color */
  borderColor: {
    type: 'color',

    rgba: 'rgba(171, 179, 206, 1)',
    hex: '#ABB3CE',
    r: 171,
    g: 179,
    b: 206,
    a: 1,
  },

  /** as theme map variable border-addit-color */
  borderAdditColor: {
    type: 'color',

    rgba: 'rgba(229, 236, 252, 1)',
    hex: '#E5ECFC',
    r: 229,
    g: 236,
    b: 252,
    a: 1,
  },

  /** as theme map variable border-addit-2-color */
  borderAddit2Color: {
    type: 'color',

    rgba: 'rgba(229, 229, 255, 1)',
    hex: '#E5E5FF',
    r: 229,
    g: 229,
    b: 255,
    a: 1,
  },

  /** as theme map variable border-btn-color */
  borderBtnColor: {
    type: 'color',

    rgba: 'rgba(104, 111, 137, 1)',
    hex: '#686F89',
    r: 104,
    g: 111,
    b: 137,
    a: 1,
  },

  /** as theme map variable button-primary-color */
  buttonPrimaryColor: {
    type: 'color',

    rgba: 'rgba(56, 61, 78, 1)',
    hex: '#383D4E',
    r: 56,
    g: 61,
    b: 78,
    a: 1,
  },

  /** as theme map variable inactive-color */
  inactiveColor: {
    type: 'color',

    rgba: 'rgba(171, 179, 206, 1)',
    hex: '#ABB3CE',
    r: 171,
    g: 179,
    b: 206,
    a: 1,
  },

  /** as theme map variable success-light-color */
  successLightColor: {
    type: 'color',

    rgba: 'rgba(15, 172, 39, 1)',
    hex: '#0FAC27',
    r: 15,
    g: 172,
    b: 39,
    a: 1,
  },

  /** as theme map variable success-blue-color */
  successBlueColor: {
    type: 'color',

    rgba: 'rgba(97, 122, 255, 1)',
    hex: '#617AFF',
    r: 97,
    g: 122,
    b: 255,
    a: 1,
  },

  /** as theme map variable success-blue-2-color */
  successBlue2Color: {
    type: 'color',

    rgba: 'rgba(110, 174, 249, 1)',
    hex: '#6EAEF9',
    r: 110,
    g: 174,
    b: 249,
    a: 1,
  },

  /** as theme map variable dark-purple-color */
  darkPurpleColor: {
    type: 'color',

    rgba: 'rgba(118, 61, 239, 1)',
    hex: '#763DEF',
    r: 118,
    g: 61,
    b: 239,
    a: 1,
  },

  /** as theme map variable warning-color */
  warningColor: {
    type: 'color',

    rgba: 'rgba(255, 176, 57, 1)',
    hex: '#FFB039',
    r: 255,
    g: 176,
    b: 57,
    a: 1,
  },

  /** as theme map variable bg-dark-color */
  bgDarkColor: {
    type: 'color',

    rgba: 'rgba(56, 61, 78, 1)',
    hex: '#383D4E',
    r: 56,
    g: 61,
    b: 78,
    a: 1,
  },

  /** as theme map variable bg-additional-color */
  bgAdditionalColor: {
    type: 'color',

    rgba: 'rgba(56, 61, 78, 1)',
    hex: '#383D4E',
    r: 56,
    g: 61,
    b: 78,
    a: 1,
  },

  /** as theme map variable bg-additional-2-color */
  bgAdditional2Color: {
    type: 'color',

    rgba: 'rgba(244, 246, 255, 1)',
    hex: '#F4F6FF',
    r: 244,
    g: 246,
    b: 255,
    a: 1,
  },

  /** as theme map variable bg-block-main-color */
  bgBlockMainColor: {
    type: 'color',

    rgba: 'rgba(245, 245, 245, 1)',
    hex: '#F5F5F5',
    r: 245,
    g: 245,
    b: 245,
    a: 1,
  },

  /** as theme map variable bg-block-addit-color */
  bgBlockAdditColor: {
    type: 'color',

    rgba: 'rgba(237, 237, 237, 1)',
    hex: '#EDEDED',
    r: 237,
    g: 237,
    b: 237,
    a: 1,
  },

  /** as theme map variable bg-block-extra-color */
  bgBlockExtraColor: {
    type: 'color',

    rgba: 'rgba(55, 67, 100, 1)',
    hex: '#374364',
    r: 55,
    g: 67,
    b: 100,
    a: 1,
  },

  /** as theme map variable bg-extra-color */
  bgExtraColor: {
    type: 'color',

    rgba: 'rgba(73, 80, 103, 1)',
    hex: '#495067',
    r: 73,
    g: 80,
    b: 103,
    a: 1,
  },

  /** as theme map variable bg-light-blue-addit */
  bgLightBlueAddit: {
    type: 'color',

    rgba: 'rgba(233, 236, 248, 1)',
    hex: '#E9ECF8',
    r: 233,
    g: 236,
    b: 248,
    a: 1,
  },

  /** as theme map variable bg-light-blue-addit-2 */
  bgLightBlueAddit2: {
    type: 'color',

    rgba: 'rgba(225, 237, 250, 1)',
    hex: '#E1EDFA',
    r: 225,
    g: 237,
    b: 250,
    a: 1,
  },

  /** as theme map variable bg-light-blue-addit-3 */
  bgLightBlueAddit3: {
    type: 'color',

    rgba: 'rgba(250, 250, 255, 1)',
    hex: '#FAFAFF',
    r: 250,
    g: 250,
    b: 255,
    a: 1,
  },

  /** as theme map variable bg-dashboard */
  bgDashboard: {
    type: 'color',

    rgba: 'rgba(104, 111, 137, 1)',
    hex: '#686F89',
    r: 104,
    g: 111,
    b: 137,
    a: 1,
  },

  /** as theme map variable bg-dashboard-addit */
  bgDashboardAddit: {
    type: 'color',

    rgba: 'rgba(56, 61, 78, 1)',
    hex: '#383D4E',
    r: 56,
    g: 61,
    b: 78,
    a: 1,
  },

  /** as theme map variable text-additional-color */
  textAdditionalColor: {
    type: 'color',

    rgba: 'rgba(171, 179, 206, 1)',
    hex: '#ABB3CE',
    r: 171,
    g: 179,
    b: 206,
    a: 1,
  },

  /** as theme map variable text-additional-2-color */
  textAdditional2Color: {
    type: 'color',

    rgba: 'rgba(158, 158, 158, 1)',
    hex: '#9E9E9E',
    r: 158,
    g: 158,
    b: 158,
    a: 1,
  },

  /** as theme map variable text-additional-3-color */
  textAdditional3Color: {
    type: 'color',

    rgba: 'rgba(104, 111, 137, 1)',
    hex: '#686F89',
    r: 104,
    g: 111,
    b: 137,
    a: 1,
  },

  /** as theme map variable text-extra-color */
  textExtraColor: {
    type: 'color',

    rgba: 'rgba(175, 175, 175, 1)',
    hex: '#AFAFAF',
    r: 175,
    g: 175,
    b: 175,
    a: 1,
  },

  /** as theme map variable text-inverse-color */
  textInverseColor: {
    type: 'color',

    rgba: 'rgba(255, 255, 255, 1)',
    hex: '#FFFFFF',
    r: 255,
    g: 255,
    b: 255,
    a: 1,
  },

  /** as theme map variable text-static-color */
  textStaticColor: {
    type: 'color',

    rgba: 'rgba(255, 255, 255, 1)',
    hex: '#FFFFFF',
    r: 255,
    g: 255,
    b: 255,
    a: 1,
  },

  /** as theme map variable text-link-color */
  textLinkColor: {
    type: 'color',

    rgba: 'rgba(97, 122, 255, 1)',
    hex: '#617AFF',
    r: 97,
    g: 122,
    b: 255,
    a: 1,
  },

  /** as theme map variable border-color-additional */
  borderColorAdditional: {
    type: 'color',

    rgba: 'rgba(240, 240, 240, 1)',
    hex: '#F0F0F0',
    r: 240,
    g: 240,
    b: 240,
    a: 1,
  },

  /** as theme map variable border-color-additional-2 */
  borderColorAdditional2: {
    type: 'color',

    rgba: 'rgba(234, 234, 234, 1)',
    hex: '#EAEAEA',
    r: 234,
    g: 234,
    b: 234,
    a: 1,
  },

  /** as theme map variable border-color-light */
  borderColorLight: {
    type: 'color',

    rgba: 'rgba(82, 91, 116, 1)',
    hex: '#525B74',
    r: 82,
    g: 91,
    b: 116,
    a: 1,
  },

  /** as theme map variable border-color-dark */
  borderColorDark: {
    type: 'color',

    rgba: 'rgba(56, 61, 78, 1)',
    hex: '#383D4E',
    r: 56,
    g: 61,
    b: 78,
    a: 1,
  },

  /** as theme map variable shadow-color */
  shadowColor: {
    type: 'color',

    rgba: 'rgba(0, 0, 0, 0.08)',
    hex: '#000000',
    r: 0,
    g: 0,
    b: 0,
    a: 0.08,
  },

  /** as theme map variable box-shadow */
  boxShadow: {
    type: 'box-shadow',

    rgba: 'rgba(0, 0, 0, 0.08)',
    hex: '#000000',
    r: 0,
    g: 0,
    b: 0,
    a: 0.08,

    boxShadowParams: ['0', '0', '8px', '0'],
  },

  /** as theme map variable field-focused-color */
  fieldFocusedColor: {
    type: 'color',

    rgba: 'rgba(97, 122, 255, 1)',
    hex: '#617AFF',
    r: 97,
    g: 122,
    b: 255,
    a: 1,
  },
};
